import React, { Component, createRef } from "react";
import { Modal } from "react-bootstrap";
import Form from "../../comman/form";
import auth from "../../services/authService";
import http from "../../services/HttpService";
import config from "../../config.json";
import Swal from "sweetalert2";
import { getAlert } from "../../services/appAlerts";

class UploadInvoice extends Form {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      errors: {},
      documents: [],
      isDragging: false,
    };
    this.fileInputRef = createRef();
  }

  schema = {};

  componentDidMount() { }

  doSubmit = async () => {
    const { data, documents } = this.state;
    const user = auth.getCurrentUser();
    const { wfTask: workflowTask } = this.props;
    let docId = 0;

    if (documents.length > 0) {
      const frmData = new FormData();
      frmData.append("message", data["notes"]);
      frmData.append("workflowTask", JSON.stringify(workflowTask));
      frmData.append("userId", user.id);

      documents.forEach((file, key) =>
        frmData.append("files[" + key + "]", file.file)
      );


      const { data: result } = await http.post(
        config.ApplicantUploadDocument,
        frmData
      );
      docId = result;
    }

    const { selectedObj } = this.props;
    const tmObj = {
      id: selectedObj.id,
      invoiceDocId: docId,
      notes: data["notes"],
      remarks: data["invNumber"],
      docUploadType: "agency",
    };

    await http.post(config.UpdateTimeLogInvoice, tmObj);
    this.props.handleInvShowHide("save");
    getAlert("Invoice Uploaded Successfully", "", "success");
  };

  // getAlert(title, message, type) {
  //   return Swal.fire({
  //     title,
  //     text: message,
  //     icon: type,
  //     confirmButtonText: "Close",
  //     confirmButtonColor: "#d33",
  //   });
  // }

  handleDragOver = (e) => {
    e.preventDefault();
    this.setState({ isDragging: true });
  };

  handleDragLeave = (e) => {
    e.preventDefault();
    this.setState({ isDragging: false });
  };

  handleDrop = (e) => {
    e.preventDefault();
    this.setState({ isDragging: false });
    const droppedFiles = Array.from(e.dataTransfer.files);
    const docs = [
      ...this.state.documents,
      ...droppedFiles.map((file) => ({
        name: file.name,
        type: file.type,
        file,
      })),
    ];
    this.setState({ documents: docs });
  };

  onFileChange = (event) => {
    const selectedFiles = Array.from(event.target.files);
    const docs = [
      ...this.state.documents,
      ...selectedFiles.map((file) => ({
        name: file.name,
        type: file.type,
        file,
      })),
    ];
    this.setState({ documents: docs });
  };

  handleFileRemove = (item) => {
    const { documents } = this.state;
    const updatedDocuments = documents.filter((doc) => doc !== item);
    this.setState({ documents: updatedDocuments });
  };

  render() {
    const { invShowHide, handleInvShowHide } = this.props;
    const { isDragging, documents } = this.state;

    return (
      <Modal show={invShowHide} size="xl">
        <Modal.Header closeButton onClick={() => handleInvShowHide("")}>
          <Modal.Title>Upload Invoice</Modal.Title>
        </Modal.Header>
        <Modal.Body className="border">
          <div className="row">
            <div className="col-md-12">
              {this.renderInput("invNumber", "Invoice Number")}
            </div>

            {/* Drag & Drop Upload */}
            <div className="col-md-12 form-group">
              <label className="form-control-label">Upload Invoice File</label>
              <div
                className={`drop-zone w-100 text-center border rounded ${isDragging ? "bg-light" : ""
                  }`}
                onDragOver={this.handleDragOver}
                onDragLeave={this.handleDragLeave}
                onDrop={this.handleDrop}
                onClick={() => this.fileInputRef.current.click()}
                style={{
                  border: "2px dotted #666",
                  borderRadius: "8px",
                  padding: "30px",
                  textAlign: "center",
                  background: isDragging ? "#f0f8ff" : "#fafafa",
                  cursor: "pointer",
                  transition: "background 0.2s ease",
                }}
              >
                <i
                  className="fa fa-cloud-upload fa-2x mb-2"
                  aria-hidden="true"
                  style={{ color: "black" }}
                ></i>
                <p className="mb-0">
                  {isDragging
                    ? "Drop files here..."
                    : "Drag & drop invoice here, or click to select"}
                </p>
                <input
                  type="file"
                  ref={this.fileInputRef}
                  onChange={this.onFileChange}
                  multiple
                  hidden
                />
              </div>

              {/* File list */}
              {/* {documents.length > 0 && (
                <ul className="list-group mt-2">
                  {documents.map((doc, idx) => (
                    <li
                      key={idx}
                      className="list-group-item d-flex justify-content-between align-items-center"
                    >
                      {doc.name}
                      <span className="badge bg-secondary">
                        {doc.type || "file"}
                      </span>
                    </li>
                  ))}
                </ul>
              )} */}
              {documents.length > 0 && (
                <div className="file-preview">
                  {documents.map((file, index) => (
                    <div key={index} className="file-preview-item ml-1">
                      <span>{file.name}</span>
                      <span
                        className="file-size"
                        style={{
                          backgroundColor: "#f0f0f0",
                          marginLeft: "10px",
                          padding: "2px 5px",
                          borderRadius: "5px",
                        }}
                      >
                        {file.size} KB
                      </span>
                      <button
                        className="btn btn-sm btn-link"
                        onClick={() => this.handleFileRemove(file)}
                      >
                        <i className="fa fa-times text-red" aria-hidden="true"></i>
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>

            <div className="col-md-12">{this.renderTextArea("notes", "Notes")}</div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-sm btn-outline-default"
            onClick={this.handleSubmit}
          >
            <i className="fa fa-check"></i> Save
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default UploadInvoice;
